"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportStatsCardsTranslations = {
    "en": {
        ready: "Ready",
        onphone: "On phone",
        busy: "Other queue busy",
        wrapup: "Wrap up",
        idle: "Idle",
        calling: "Ringing",
        loggedout: "Logged out",
        lastLoggedIn: "Last logged in",
        lastLoggedOut: "Last logged out",
        agentStatus: "Agent Status",
        totalCalls: "Total calls",
        rolledCalls: "Rolled calls",
        callsPerHour: "Calls per hour (Avg)",
        currentStatus: "Current status",
    },
    "de": {
        wrapup: "Abschließen",
        idle: "Inaktiv",
        currentStatus: "Aktueller Status",
        lastLoggedOut: "Zuletzt ausgeloggt",
        loggedout: "Ausgeloggt",
        onphone: "Am Telefon",
        agentStatus: "Mitarbeiterstatus",
        totalCalls: "Gesamtzahl der Anrufe",
        ready: "Bereit",
        busy: "Andere Warteschlange besetzt",
        calling: "Läutet",
        lastLoggedIn: "Zuletzt eingeloggt",
        rolledCalls: "Umgeleitete Gespräche",
        callsPerHour: "Anrufe pro Stunde (Durchschn.)",
    },
    "nl": {
        wrapup: "Afronden",
        idle: "Niet bezet",
        currentStatus: "Huidige status",
        lastLoggedOut: "Laatst uitgelogd",
        loggedout: "Uitgelogd",
        onphone: "Verbonden",
        agentStatus: "Agentstatus",
        totalCalls: "Totale oproepen",
        ready: "Klaar",
        busy: "Andere rij bezig",
        calling: "Bellen",
        lastLoggedIn: "Laatst ingelogd",
        rolledCalls: "Doorgegeven oproepen",
        callsPerHour: "Oproepen per uur (gem.)",
    },
    "it": {
        wrapup: "Concludere",
        idle: "Inattivo",
        currentStatus: "Stato attuale",
        lastLoggedOut: "Ultima disconnessione",
        loggedout: "Disconnesso",
        onphone: "Al telefono",
        agentStatus: "Stato agente",
        totalCalls: "Chiamate totali",
        ready: "Disponibile",
        busy: "Occupato in un altra coda",
        calling: "Sta suonando",
        lastLoggedIn: "Ultimo accesso",
        rolledCalls: "Chiamate inoltrate",
        callsPerHour: "Chiamate / ora (media)",
    },
    "fr": {
        wrapup: "Conclure",
        idle: "Inactif",
        currentStatus: "Statut actuel",
        lastLoggedOut: "Dernière déconnexion",
        loggedout: "Déconnecté",
        onphone: "En appel",
        agentStatus: "Statut de l'agent",
        totalCalls: "Nombre total d'appels",
        ready: "Prêt",
        busy: "Autre file d'attente occupée",
        calling: "Sonnerie",
        lastLoggedIn: "Dernière connexion",
        rolledCalls: "Appels connectés",
        callsPerHour: "Nombre d'appels par heure (moyenne)",
    },
    "es": {
        wrapup: "Concluir",
        idle: "Inactivo",
        currentStatus: "Estado actual",
        lastLoggedOut: "Última vez que finalizó sesión o se desconectó",
        loggedout: "Sesión cerrada",
        onphone: "Al teléfono",
        agentStatus: "Estado del agente",
        totalCalls: "Total de llamadas",
        ready: "Listo",
        busy: "La otra cola de espera esta ocupada",
        calling: "Sonando",
        lastLoggedIn: "Última vez que inició sesión o se conectó",
        rolledCalls: "Llamadas trasladadas",
        callsPerHour: "Llamadas por hora (promedio)",
    },
    "ja": {
        wrapup: "ラップアップ",
        idle: "不稼働",
        currentStatus: "現在のステータス",
        lastLoggedOut: "最近のログアウト",
        loggedout: "ログアウト済み",
        onphone: "電話中",
        agentStatus: "エージェントステータス",
        totalCalls: "合計通話数",
        ready: "応答可能",
        busy: "他のキューが使用中",
        calling: "呼び出し中",
        lastLoggedIn: "最近のログイン",
        rolledCalls: "無応答転送通話",
        callsPerHour: "時間あたり通話（平均）",
    },
    "en-GB": {
        wrapup: "Wrap up",
        idle: "Idle",
        currentStatus: "Current status",
        lastLoggedOut: "Last logged out",
        loggedout: "Logged out",
        onphone: "On phone",
        agentStatus: "Agent Status",
        totalCalls: "Total calls",
        ready: "Ready",
        busy: "Other queue busy",
        calling: "Ringing",
        lastLoggedIn: "Last logged in",
        rolledCalls: "Rolled calls",
        callsPerHour: "Calls per hour (Avg)",
    },
    "ru": {
        ready: "Готов",
        onphone: "На телефоне",
        busy: "Временно не доступен",
        wrapup: "Завершает звонок",
        idle: "Не доступен",
        calling: "Звонит",
        loggedout: "Не в сети",
        lastLoggedIn: "Последний вход",
        lastLoggedOut: "Последний выход",
        agentStatus: "Статус Агента",
        totalCalls: "Всего звонков",
        rolledCalls: "Перенаправленные звонки",
        callsPerHour: "Звонков за час (Среднее)",
        currentStatus: "Текущий статус",
    },
};
